import { createTheme } from '@mui/material/styles';

// Brand colors from Figma design
const theme = createTheme({
  palette: {
    primary: {
      main: '#1A65C9', // Blue
    },
    secondary: {
      main: '#43AB32', // Green
    },
    background: {
      default: '#FFFFFF',
      paper: '#FAFAFA',
    },
    text: {
      primary: '#1E1E1E',
      secondary: '#606060',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    h1: {
      fontSize: '72px',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '52px',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontSize: '24px',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    subtitle1: {
      fontSize: '18px',
      fontWeight: 500,
    },
    caption: {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '53px',
          textTransform: 'none',
          fontSize: '20px',
          fontWeight: 500,
          padding: '10px 20px',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          padding: 0,
        },
      },
    },
  },
});

// Gradient styles for reuse
export const gradients = {
  primary: 'linear-gradient(100deg, #1A65C9 40.95%, #43AB32 101.66%)',
  primaryText: {
    background: 'linear-gradient(100deg, #1A65C9 40.95%, #43AB32 101.66%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
};

export default theme;
